import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgEmbed = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.76949 17.1655C10.368 17.4342 11.0908 17.1244 11.3595 16.525L14.8491 8.43003C14.9733 8.14125 14.9733 7.8105 14.87 7.50074C14.7458 7.19097 14.5191 6.96348 14.2295 6.84007C14.0851 6.77796 13.9198 6.73682 13.7544 6.73682C13.2792 6.73682 12.8461 7.0256 12.6396 7.4596L9.14995 15.5757C9.02572 15.8644 9.02572 16.1952 9.12898 16.505C9.25321 16.7937 9.48069 17.0212 9.76949 17.1656V17.1655ZM18.2164 7.17086C17.9889 6.90223 17.659 6.75784 17.3081 6.75784C17.0193 6.75784 16.7297 6.8611 16.5232 7.04663C16.2755 7.25314 16.1311 7.54192 16.1101 7.87267C16.0892 8.20341 16.1924 8.51318 16.3989 8.73984L19.1868 12.0029L16.3779 15.266C15.9439 15.7613 16.006 16.526 16.5021 16.9592C16.9974 17.3722 17.7823 17.3101 18.1953 16.835L21.706 12.7878C22.098 12.3336 22.098 11.673 21.706 11.218L18.2164 7.17086ZM7.62215 15.2658C8.05534 15.7611 7.99322 16.525 7.49793 16.959L7.49784 16.9591C7.00252 17.3721 6.19666 17.31 5.78364 16.8357L2.29403 12.7877C1.90199 12.3327 1.90199 11.672 2.29403 11.2179L5.8047 7.17069C6.03137 6.90207 6.36211 6.75767 6.71301 6.75767C7.00262 6.75767 7.27043 6.86092 7.49792 7.04646C7.74557 7.25297 7.88997 7.54175 7.91094 7.8725C7.93192 8.18226 7.82866 8.49203 7.62215 8.73968L4.8132 12.0027L7.62215 15.2658Z", fill: props.fill }));
});
export default SvgEmbed;
